import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class FileManagerService {
  private headers: HttpHeaders;
  private urlHeaders: HttpHeaders;
  private multipartHeaders: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    this.urlHeaders = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
    this.multipartHeaders = new HttpHeaders({'Content-Type': 'multipart/form-data'})
  }

  AzureFileDownload(itemID) {
    return this.http.get<any>('FileManager/AzureFileDownload?ItemID=' + itemID,{ headers: this.headers });
  }

  UploadBlobFiles(uploadjobDocDetails, formData) {
    return this.http.post<any>('FileManager/UploadBlobFiles/?FinancialYear=' + uploadjobDocDetails.financialYear + '&ContextId=' + uploadjobDocDetails.jobId + '&DocumentTypeId=' + uploadjobDocDetails.folderTypeId, formData, { headers: this.multipartHeaders })
  }

  GetDocumentTypeByJobId(JobId) {
   return this.http.get<any>('FileManager/GetDocumentTypeByJobId?jobId=' + Number(JobId) + '', { headers: this.headers })
  }

  UploadClientCommunicationBlobFiles(communication, CommunicationForm, ddate) {
    return  this.http.post<any>('FileManager/UploadClientCommunicationBlobFiles/?ContextId=' + communication.clientId + '&CommunicationId=' + communication.communicationID + '&Subject=' + CommunicationForm.value.name + '&Description=' + CommunicationForm.value.Description + '&Type=' + CommunicationForm.value.communicationType + '&Title=' + CommunicationForm.value.title + '&date=' + ddate, { headers: this.multipartHeaders })
  }

  AzureFileDownloadBlobObj(itemID) {
    return this.http.get('FileManager/AzureFileDownload?ItemID=' + itemID, { responseType: 'blob' })
  }

  SaveSharedDocUsersDetails(SharedDocItemId, SharedUsers) {
    return this.http.post<any>('FileManager/SaveSharedDocUsersDetails?ItemId=' + SharedDocItemId + '&SharedUserIds=' + SharedUsers, { headers: this.multipartHeaders })
  }

  GetSharedUserDetails(id) {
    return this.http.get<any>('FileManager/GetSharedUserDetails?ItemId=' + id, { headers: this.multipartHeaders })
  }

  UploadClientBlobFiles(documentForm, formData){
    return this.http.post<any>('FileManager/UploadClientBlobFiles/?ContextId=' + documentForm.value.clientId.clientId + '&DocumentTypeId=' + documentForm.value.documentTypeId, formData, { headers: this.multipartHeaders })
  }

  getDocumentTypeByJobId(jobId){
    return this.http.get<any>('FileManager/GetDocumentTypeByJobId?jobId=' + jobId + '');

  }

   azureFileDownload(itemID: number) {
    return this.http.get(`FileManager/AzureFileDownload?ItemID=${itemID}`, {
      responseType: 'blob'
    });
  }
}